<form class="form" [formGroup]="form">
  <p class="form-description">
    This client will receive an email invitation to create an account on SonderMind. They'll appear as a client in your portal.
  </p>
  <div class="form-row">
    <div class="field-wrapper">
      <iris-form-field class="large-field">
        <iris-text-input
          type="text"
          formControlName="firstName"
          placeholder="First Name"
          data-test="first-name"
        ></iris-text-input>
      </iris-form-field>
    </div>
    <div class="field-wrapper">
      <iris-form-field class="large-field">
        <iris-text-input
          type="text"
          formControlName="lastName"
          placeholder="Last Name"
          data-test="last-name"
        ></iris-text-input>
      </iris-form-field>
    </div>
    <div class="field-wrapper">
      <iris-form-field class="large-field">
        <iris-text-input
          type="text"
          formControlName="email"
          placeholder="Email"
          data-test="email"
        ></iris-text-input>
      </iris-form-field>
    </div>
  </div>

  @if (phoneNumberRequired) {
    <div class="form-row">
      <div class="field-wrapper">
        <iris-form-field class="large-field">
          <iris-text-input
            type="tel"
            formControlName="phoneNumber"
            placeholder="Phone Number"
            [mask]="phoneMask"
            data-test="phone-number"
          ></iris-text-input>
        </iris-form-field>
        @if (phoneNumberError) {
          <div class="form-error-message" role="alert" [attr.aria-live]="'polite'" data-test="phone-number-error">
            {{ phoneNumberError }}
          </div>
        }
      </div>
    </div>
  }

  @if (formLevelError) {
    <div class="form-error-message" role="alert" [attr.aria-live]="'polite'">
      {{ formLevelError }}
    </div>
  }

  <div class="form-row">
    <div class="field-wrapper intake-required-field">
      <iris-form-field class="large-field">
        <label class="iris-label-responsive">Will this client require an intake session on SonderMind?</label>
        <iris-radio-group
          [options]="intakeRequiredOptions"
          formControlName="intakeRequired"
          [canBeNull]="false"
          data-test="intake-required"
        ></iris-radio-group>
      </iris-form-field>
    </div>
  </div>

  <br>

  <iris-button-container [alignment]="irisButtonContainerAlignments.END" data-dd-privacy="allow">
    @if (cancelable) {
      <iris-button
        (click)="handleCancel($event)"
        [disabled]="saving"
        [type]="irisButtonTypes.SECONDARY"
        aria-label="Cancel Invite Client"
        data-test="cancel-invite-client"
      >Cancel</iris-button>
    }
    <iris-button
      (click)="handleSave($event)"
      [disabled]="saving"
      aria-label="Invite Client"
      data-test="invite-client"
    >Add client</iris-button>
  </iris-button-container>
</form>
